<script setup lang="ts">
import { computed } from 'vue'
import { useRoute } from 'vue-router'
import Breadcrumb from '@/components/ui/Breadcrumb.vue'

const props = withDefaults(defineProps<{
  /** Whether to show the breadcrumb strip */
  show?: boolean
  /** Passed on to the breadcrumb (showHome, homeLabel, homePath) */
  breadcrumbProps?: Record<string, unknown>
}>(), {
  show: true,
  breadcrumbProps: () => ({}),
})

// The dashboard is the top of the trail, and the sign-in pages have none
const HIDDEN_ON = ['login', 'signup', 'singup', 'forgot-password', 'reset-password', 'not-found', 'home']

const route = useRoute()
const visible = computed(() => props.show && !HIDDEN_ON.includes(route.name as string))
</script>

<template>
  <div v-if="visible" class="breadcrumb-layout">
    <div class="ui-shell">
      <Breadcrumb v-bind="breadcrumbProps" />
    </div>
  </div>
</template>

<style scoped>
.breadcrumb-layout {
  position: relative;
  z-index: 10;
  border-bottom: 1px solid var(--ui-line);
  background: var(--ui-white);
}

@media print {
  .breadcrumb-layout {
    display: none;
  }
}
</style>
